<template>
	<ButtonShare @click="share">
		<template #icon><BaseIcon name="linear" /></template>
		Share in Linear
	</ButtonShare>
</template>

<script>
import analytics from 'shared/utils/analytics'
import ButtonShare from 'shared/components/ButtonShare.vue'

export default {
	name: 'ButtonShareLinear',
	components: {ButtonShare},
	emits: ['click'],
	methods: {
		share() {
			analytics.track('Linear Share Button Clicked')
			this.$routerHelpers.pushQueryParams({linear: 'create-issue', jira: null, github: null, azure: null})
			this.$emit('click')
		},
	},
}
</script>
